<template lang='pug'>
    v-main
      v-container(fluid)
        v-flex
          v-card
            v-toolbar(class="elevation-0" color='white')
              v-toolbar-title(v-model="title") {{ title }}
              v-spacer
              v-btn(id="btnCreateMemoDialog" class='blue-secondary elevation-0'  @click="reqTypeDialog = true") Create
              v-dialog( width="420px" style="overflow:hidden; " v-model="reqTypeDialog" persistent)
                v-card
                  h1(style="background: #E0E0E0; padding: 0.5rem; padding-left:1rem; font-size: large;") Select Request
                  div(style="padding: 0rem 1rem 0 1rem;")
                    select( required id="crMemoSlec" placeholder="Select Type" v-model="createMemoReqType" style="outline:none;border-bottom: 1px solid;width: 100%;margin-bottom: 1rem;padding: 0.1rem 0.5rem; ; margin: 2rem 0")
                      option(value='' hidden selected="true" disabled="true") Select Type
                      option(id='btnSelectGeneral' value='General') General Request
                      option(id='btnselectPayment' value='Payment') Payment Request
                      option(id='btnselectAnnouncement' value='Announcement') IM Announcement
        
                    v-card-actions(style="padding-top:0; justify-content: right; padding-bottom:1.4rem")
                      v-btn(depressed, large, id='btnSelectCreateMemoTypeCancle' style="color:#000; backgound:#f5f5f5; margin-right:.3rem"  @click="reqTypeDialog = false; createMemoReqType = ''") Cancel
                      v-btn(depressed, large, id='btnSelectCreateMemoTypeCreate' color="primary" @click="createMemo(); reqTypeDialog = false; ; createMemoReqType = ''") Create
              
            v-divider
            div(style="margin: 0.5rem; font-size: 14px; ")
              span Information : &nbsp;&nbsp;
              v-icon(small color="blue") remove_red_eye 
              span &nbsp; View Detail &nbsp;&nbsp;&nbsp;
              v-icon(small color="green") edit 
              span &nbsp; Edit &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title == 'Approval Page'" color="blue") assignment_turned_in 
              span(v-if="title == 'Approval Page'") &nbsp; Approval &nbsp;&nbsp;&nbsp;
              v-icon(small color="red") cancel 
              span &nbsp; Withdraw &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title != 'Approval Page'" color="orange") filter_none 
              span(v-if="title != 'Approval Page'") &nbsp; Copy IM &nbsp;&nbsp;&nbsp;
              v-icon(small color="green") cloud_download 
              span &nbsp; Download File &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title != 'Approval Page'" color="orange") send 
              span(v-if="title != 'Approval Page'") &nbsp; Resend Approval &nbsp;&nbsp;&nbsp;
              v-icon(small v-if="title != 'Approval Page'" color="blue") mdi-share-circle
              span(v-if="title != 'Approval Page'") &nbsp; Share URL &nbsp;&nbsp;&nbsp;
            v-divider
            v-toolbar(class="elevation-0 mt-2 mb-4" color='white')
              v-select(
                label="Business Unit" 
                :items="dataBisnisUnit" 
                item-value="value" 
                v-model="bisnisUnit" 
                hide-details 
                class='hidden-sm-and-down col-3 pl-0'
                multiple
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggle") 
                    v-list-item-action
                      v-icon(:color="bisnisUnit.length > 0 ? 'indigo darken-4' : ''") {{ iconX }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="bisnisUnit.length == 1"
                    close
                    @click:close="remove(bisnisUnit, 'bisnis unit')"
                  )
                    span {{ item.text | truncate(20, '...') }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('bisnis unit')"
                  )
                    span {{ bisnisUnit.length }} Business Unit
              span(class="pr-1")
              v-select(
                label="IM Type"
                v-model="filterImType"
                hide-details 
                multiple
                :items="dataImType" 
                item-value="value" 
                class="hidden-sm-and-down col-2 pl-0"
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggleImType") 
                    v-list-item-action
                      v-icon(:color="filterImType.length > 0 ? 'indigo darken-4' : ''") {{ iconXimType }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="filterImType.length == 1"
                    close
                    @click:close="remove(filterImType, 'imType')"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('imType')"
                  )
                    span {{ filterImType.length }} Type

              span(class="pr-1")
              v-select(
                multiple 
                label="Status" 
                hide-details 
                v-model="e3" 
                :items="dataStatus" 
                class="hidden-sm-and-down col-2 pl-0"
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggleStatus") 
                    v-list-item-action
                      v-icon(:color="e3.length > 0 ? 'indigo darken-4' : ''") {{ iconXStatus }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="e3.length == 1"
                    close
                    @click:close="remove(e3, 'status')"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('status')"
                  )
                    span {{ e3.length }} Status

              span(class="pr-1")
              v-select(
                style="padding-bottom: 0.5rem;"
                
                multiple 
                label="Category" 
                hide-details 
                v-model="category" 
                :items="dataCategory" 
                
              )
                template(v-slot:prepend-item)
                  v-list-item(ripple @mousedown.prevent @click="toggleCategory") 
                    v-list-item-action
                      v-icon(:color="e3.length > 0 ? 'indigo darken-4' : ''") {{ iconXCategory }} 
                    v-list-item-content
                      v-list-item-title Select All
                  v-divider(class="mt-2")

                template(v-slot:selection="{ item, index }")
                  v-chip(
                    v-if="category.length == 1"
                    close
                    @click:close="remove(category, 'category')"
                  )
                    span {{ item.text }}
                  v-chip(
                    v-else-if="index===1"
                    close
                    @click:close="removeAll('category')"
                  )
                    span {{ category.length }} Category

              v-text-field(flat append-icon='search' placeholder='Keyword (optional)' v-model='keyword' hide-details class='hidden-sm-and-down col-3')

            v-divider
            v-card-text(class='pa-0')
              v-data-table.elevation-1(
                :headers="filterImType == 'General' ? im.headers : im.paymentHeaders"
                :items="im.items"
                :page.sync="page"
                :options.sync="options"
                :server-items-length="im.jumlah"
                :loading="loading"
                loading-text="Loading... Please wait"
                item-key='_id'
                :sort-desc.sync="im.imDate"
                multi-sortBy
                :single-expand="true"
                :expanded.sync='expanded'
                :search='keyword'
              )

                template(v-slot:item.imStatus='{ item }')
                  template(v-if="item.imWorkflow.length > 0")
                    v-chip(v-if="item.imWorkflow && item.imStatus === 3" label small :color="i18n.status[item.imStatus].color" style="width:100%;justify-content:space-evenly" text-color="black") Need Review
                    v-chip(v-else label small :color="item.imStatusLabel == 'Need Approval' && title == 'Approval Page'?  i18n.status[9].color : i18n.status[item.imStatus].color" style="width:100%;justify-content:space-evenly" text-color="black") {{ item.imStatusLabel }}

                  template(v-else)
                    v-chip(:color="i18n.status[item.imStatus].color")
                    | {{ item.imStatusLabel }}

                //- template(v-slot:item.imStatus='{ item }')
                //-   v-chip(:color="i18n.status[item.imStatus].color")
                //-     | {{ i18n.status[item.imStatus].name }}

                template(v-slot:item.imDate='{ item }')
                    | {{ getUTC7Date(item.imDate) }}
                 
                template(v-slot:item.actions='{ item }')
                  div(class="d-flex")
                    div
                      IMView( :imItems="item" :dialogType="dialogType" :currencyConfigs="currencyConfigs")

                      v-icon.mr-2(:id="'loginActionCopyMemo_' + item._id" v-if="item.imStatus==7" title="Copy"  small=' ' color="orange" @click='')
                        | filter_none

                      router-link(v-if="listType !== 'approval'  && !item.isExternal && [1,3].includes(item.imStatus) && isReviewer(item.imWorkflow, $store.state.dataUsers.user)" :to='{ name: item.imType == 5 ? "Edit Memo" : item.imType == 6 ?"Edit Memo Payment": "Edit Memo Announcement", params: {id: item._id}}')
                        v-icon(id="loginActionEditMemo" small class='mr-2' title='Edit' color="green") edit

                      //- router-link(v-else-if="listType === 'approval' && item.imStatus == 2 && item.imStatusLabel === i18n.status[9].name" :to='{ name: "Edit Memo", params: {id: item._id}}')
                      //-   v-icon(small class='mr-2' title='Edit' color="green") edit

                      router-link(v-else-if="listType === 'approval'  && !item.isExternal && item.imStatus == 3 && isReviewer(item.imWorkflow, $store.state.dataUsers.user) && isMyNeedReview(item.imReturn)" :to='{ name: item.imType == 5 ? "Edit Memo" : item.imType == 6 ?"Edit Memo Payment": "Edit Memo Announcement", params: {id: item._id}}')
                        v-icon(id="loginActionEditMemo" small class='mr-2' title='Edit' color="green") edit


                      v-icon.mr-2(id="loginActionDownloadAttacment" v-if="item.imFileLampiran && item.imFileLampiran.length > 0" title="Download Attachment Files"  small='' color="green darken-1" @click='download(item.imNo)')
                        | cloud_download


                      ApprovalDialog(
                        :imItems="item"
                        v-if="title == 'Approval Page' && item.imStatusLabel === i18n.status[9].name"
                      )
                      ApprovalDialog(
                        v-if="title == 'Approval Page' && item.imStatus == 3 && isReviewer(item.imWorkflow, $store.state.dataUsers.user) && isMyNeedReview(item.imReturn)" 
                        :imItems="item"
                      )
                    

                      WithdrawDialog(
                        small 
                        class='mr-2'
                        v-if="listType === 'user' && [1,2,3].includes(item.imStatus) && !item.isExternal" 
                        :imId="item._id"
                        :im="item"
                      )
                      WithdrawDialog(
                        small 
                        class='mr-2'
                        v-else-if="item.imStatus == 3 && isReviewer(item.imWorkflow, $store.state.dataUsers.user) && isMyNeedReview(item.imReturn) && !item.isExternal" 
                        :imId="item._id" 
                        :type="item.imType"
                        :im="item"
                        creator
                      )

                      ResendNotif(
                        :imNo="item.imNo"
                        v-if="title == 'My IM Request' && [2,3].includes(item.imStatus)"
                      )
                      CopyIM(
                        class='mr-2'
                        :imNo="item._id"
                        :imType="item.imType"
                        v-if="title == 'My IM Request' && item.imStatus != 1 && !item.isExternal"
                      )

                      ShareURLDialog(
                        class='ml-2'
                        :im="item"
                        v-if="title == 'My IM Request' && item.imStatus == 2 "
                      )

                      ShareURLDialog(
                        class='ml-2'
                        :im="item"
                        v-if="title == 'My IM Request' && item.imStatus == 3 &&  !isMyNeedReview(item.imReturn)"
                      )

                    div(class="ml-auto")
                      v-icon(title="Timeline" small='' right color="dark" @click="clickColumn(item)")
                        | expand_more 
                
                template(v-slot:expanded-item='{ headers, item}' item-key="item")
                    td(:colspan='headers.length')
                      v-card.mt-5.mb-5
                        v-card-title(class="blue-secondary")
                          v-icon.mr-2.white--text timeline 
                          span(style="font-size:20px;") Approval Timeline
                        v-card-text.py-0
                          v-timeline(dense v-if="item.imWorkflow.length > 0")
                            v-timeline-item(icon='edit' color='teal accent-3' right="" )
                                v-card.elevation-2 
                                    v-card-text(v-if="item.imReSubmitedDate && item.imReSubmitedDate != null && item.imStatus == 3")
                                      | {{ getUTC7Date(item.imDate) }} - {{item.imStatus == 3 && (getReviewer(item).id == item.imUser.id) ? 'Need Reviewed' : 'Submited'}} by {{ item.imUseAlias ? item.imUser.alias : item.imUser.name }}  
                                    v-card-text(v-else-if="item.imReSubmitedDate && item.imReSubmitedDate != null") {{ getUTC7Date(item.imReSubmitedDate) }} - ReSubmited by {{ item.imUseAlias ? item.imUser.alias : item.imUser.name }}
                                    v-card-text(v-else)
                                      | {{ getUTC7Date(item.imDate) }} - {{item.imStatus == 3 && (getReviewer(item).id == item.imUser.id) ? 'Need Reviewed' : 'Submited'}} by {{ item.imUseAlias ? item.imUser.alias : item.imUser.name }}  
                            
                            v-timeline-item(
                              v-for="(data, i) in item.imWorkflow"
                              :color="getStatus(data, 'status', item.imWorkflow)"
                              :icon="getStatus(data, 'icon', item.imWorkflow)" 
                              :key="i"
                            )
                                template(v-slot:opposite='' )

                                v-card.elevation-2
                                    v-card-text

                                      span(v-if="data.date") {{ getUTC7Date(data.date) }} -&nbsp;

                                      template(v-if="data.status == 5")
                                        span {{ i18n.status[data.status].name }} 
                                        span(v-if="item.imWorkflow[0].hasOwnProperty('comment')") by {{ data.user }} ({{ data.position }})
                                        div(v-if="item.imWorkflow[0].hasOwnProperty('comment')")
                                          div Comment: 
                                          div {{ data.comment }}
                                        //- span(v-if="data.status == 3 || data.status == 7") &nbsp;

                                      
                                      template(v-else-if="data.status != 9")
                                        span(v-if="data.status != 6 && data.status!=null" ) {{ i18n.status[data.status].name }} by 
                                        span(v-if="data.status == 13" ) {{ i18n.status[data.status].name }} by 
                                        span(v-if="item.imStatus == 3 && data.status == 6 && data.date " ) {{ i18n.status[data.status].name }} by 

                                      span(v-if="data.status != 5") {{ item.imUseAlias ? data.alias : data.name }} {{ item.imHideTitle ? '' : data.position ? "(" + data.position + ")" : '' }}

                                      span(v-if="data.status == 9 && item.imStatus != 5")  - {{ i18n.status[data.status].name }}

                                      template(v-if="![5,8].includes(item.imStatus)")
                                        span(v-if="data.status == null || data.status == 6 && !data.hasOwnProperty('date') || data.status == 6 && data.date == null")  - waiting

                                      template(v-if="item.imStatus != 5")
                                        v-card {{ (data.comment !== null && data.comment !== '' && data.comment !== undefined) ? 'Comment : '+data.comment : '' }}

                                      
                template(v-slot:no-data)
                  div.pa-15 
                    img(src="../assets/icon/empty.png")
                    div(class="empty__title mt-1") Data not found
                    div(class="empty__subtitle") Data is empty or Try adjusting your filters.                    
                                      

</template>
<style scoped>
.v-badge__badge {
  width: auto;
  border-radius: 12px;
  padding: 5px;
}
</style>

<script>
//import io from "socket.io-client";

import axios from "axios";
import * as i18n from "../data/i18n.json";
import IMView from "@/components/IMView.vue";
import ProposalView from "@/components/ProposalView.vue";
import modal from "@/components/IMModal.vue";
import ApprovalDialog from "@/components/ApprovalDialog.vue";
import WithdrawDialog from "@/components/WithdrawDialog.vue";
import PiprTrack from "@/components/PiprTrack.vue";
import ChangeManagementNotif from "@/components/ChangeManagementNotif.vue";
import ResendNotif from "@/components/ResendNotif.vue";
import ShareURLDialog from "@/components/ShareURLDialog.vue";
import CopyIM from "@/components/CopyIM.vue";
import { mapState, mapMutations  } from "vuex";
export default {
  name: "IMList",
  components: {
    IMView,
    ProposalView,
    ApprovalDialog,
    WithdrawDialog,
    PiprTrack,
    modal,
    ChangeManagementNotif,
    ResendNotif,
    ShareURLDialog,
    CopyIM
  },
  props: {
    title: String,
    listType: String,
    dialogType: String,
    im: Object,
    header:Array
  },
  data() {
    return {
      filterImType:[],
      createMemoReqType:"",
      reqTypeDialog: false,
      exportFilename: "",
      memoInRange: [],
      memoInRangeField: {
        "IM Number": "imNo",
        "Creator": "imUser.alias",
        "IM Date": "imDate",
        "Subject": "imPerihal",
        "BU": "imOrganization.name",
        "Status": "Stat",
        "Approver": "Appvs",
        "Tanggal Approved": "AppvDates"
      },
      currencyConfigs:{},
      menu: false,
      exportDates: "",
      exportDialog: false,
      selectAllBUApproval: true,
      itemsPerPage: 10,
      page:1,
      i18n: i18n.default,
      dialog: false,
      e1: "",
      e2: "",
      e3: "",
      e6: 0,
      keyword: "",
      request:null,
      options:{
        sortBy: ['imDate'],
        sortDesc: [true]
      },
      status_request: [
        { text: "Draft", value: 1 },
        { text: "On Approval", value: 2 },
        { text: "Need Review", value: 3 },
        { text: "Rejected", value: 8 },
        { text: "Fully Approved", value: 4 },
        { text: "Withdraw", value: 5 }
      ],
      status_approval: [
        { text: "Need Approval", value: 9 },
        { text: "On Approval", value: 2 },
        { text: "Need Review", value: 3 },
        { text: "Rejected", value: 8 },
        { text: "Fully Approved", value: 4 },
        { text: "Withdraw", value: 5 }
      ],
      //socket: io.connect(this.$store.state.API_URL),
      imStat: "",
      wizardType: null,
      loading: false,
      dataImType: [
        { text: "General", value: 5 },
        { text: "Payment", value: 6 },
        { text: "Announcement", value: 7 },
      ],
      bisnis_unit: [],
      bisnisUnit: '',
      bisnis_unit_approval: [],
      expanded:[],
      dataCategory: i18n.category,
      category: ""
    };
  },
  mounted() {
    // this.group = this.$store.state.isImGroup ? this.group : 'nongroup';
    this.getBisnisUnit()
  },
  watch: {
    options(val){
        this.itemsPerPage = val.itemsPerPage
        this.getOptions()
    },

    keyword() {
      // this.getPagination();
      this.getOptions()
    },
    bisnisUnit() {
      this.page=1
      // this.getPagination();
      this.getOptions()
    },
    filterImType() {
      this.page=1
      // this.category = []
      if (this.$route.name == "My Approval") this.e3 = [3,9]
      // else this.e3 = []
      this.getOptions()
    },
    e3() {
      this.page=1
      // this.getPagination();
      this.getOptions()
    },
    category() {
      this.page=1
      this.getOptions()
    }
  },
  beforeDestroy(){
    switch(this.title){
      case 'Approval Page':
        this.$store.state.dataReqApproval.data = [];
        this.$store.state.dataReqApproval.jumlah = 0
        break;
      case 'My IM Request':
        this.$store.state.dataRequests.data = [];
        this.$store.state.dataRequests.jumlah = 0;
        break;
    }
  },
  computed: {
    ...mapState(["dataUsers", "API_URL"]),
    search2: function() {
      return this.bisnisUnit + "_" + this.e3 + "_" + this.keyword;
    },
    dateRangeText () {
        return this.exportDates.join(' ~ ')
      },
    filteredData: function() {
      let tujuan = this.tujuan_req;
      return tujuan.filter(x => x.dep == this.e1);
    },
    dataTipe() {
      let result = [{ text: "All", value: "" }];
      for (const val in this.i18n.imType) {
        result.push({
          text: this.i18n.imType[val],
          value: val
        });
      }
      return result;
    },
    dataStatus() {
      if (this.title == 'My IM Request') {
        return this.status_request;
      } else {
        this.e3 = [3,9]
        return this.status_approval;
      }
    },
    dataBisnisUnit() {
      function compare( a, b ) {
        if ( a.text < b.text ){
          return -1;
        }
        if ( a.text > b.text ){
          return 1;
        }
        return 0;
      }
      if (this.title == 'My IM Request' || this.title == 'Export List IM') {
        return this.bisnis_unit.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i).sort( compare )
      } else {
        const result = this.bisnis_unit_approval.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i).sort( compare )
        result.push({ text: "Other", value: "other" })
        return result
      }
    },

    selectAllBU () {
      if (this.bisnisUnit.length === this.bisnisUnit.length) this.selectAllBUApproval = true
      return this.bisnisUnit.length === this.dataBisnisUnit.length
    },
    selectSomeBU () {
      if (this.bisnisUnit.length > 0 && !this.selectAllBU) this.selectAllBUApproval = false
      return this.bisnisUnit.length > 0 && !this.selectAllBU
    },
    iconX () {

      if (this.selectAllBU) return 'close'
      else if (this.selectSomeBU) return 'clear_all'
      else return 'check_box_outline_blank'
    },

    selectAllStatus () {
      return this.e3.length === this.dataStatus.length
    },
    selectSomeStatus () {
      return this.e3.length > 0 && !this.selectAllStatus
    },
    selectAllImType () {
      return this.filterImType.length === this.dataImType.length
    },
    selectSomeImType () {
      return this.filterImType.length > 0 && !this.selectAllImType
    },
    iconXStatus () {
      if (this.selectAllStatus) return 'close'
      else if (this.selectSomeStatus) return 'clear_all'
      else return 'check_box_outline_blank'
    },
    iconXimType () {
      if (this.selectAllImType) return 'close'
      else if (this.selectSomeImType) return 'clear_all'
      else return 'check_box_outline_blank'
    },
    selectAllCategory () {
      return this.category.length === this.dataCategory.length
    },
    selectSomeCategory () {
      return this.category.length > 0 && !this.selectAllCategory
    },
    iconXCategory () {

      if (this.selectAllCategory) return 'close'
      else if (this.selectSomeCategory) return 'clear_all'
      else return 'check_box_outline_blank'
    },
  },
  async created(){

    if (sessionStorage.getItem('hasRefreshed')) {
      sessionStorage.removeItem('hasRefreshed');
    }
    await this.fetchCurrencyConfigs()
  },
  methods: {

    async fetchCurrencyConfigs() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_OLD}/api/currency`)
        this.currencyConfigs = response.data
      } catch (error) {
        console.error('Error fetching currency configurations:', error)
        // Fallback to default configurations...
      }
    },
    //- ...mapMutations([""]),
    isMyNeedReview: function(itemRtDetail) {

      const loginedUserBu = this.$store.state.dataUsers.user.bu

      for(let i in loginedUserBu) {
        //- for(let j in itemRtDetail) {
          if (loginedUserBu[i].id == itemRtDetail[itemRtDetail.length-1].id) {
            return true
          //- }
        }
      }
      return false
    },
    createMemo() {
      if (this.createMemoReqType == 'General') {
        //- setCreateMemoRequestType()
        this.$store.commit('setCreateMemoRequestType', "General");
        this.$router.push('/create-memo');
      } else if (this.createMemoReqType == 'Payment') {
        
        //- THERW WILL BE A NEW PAGE CALLED CREATE PAYMENT MEMO SOON
        this.$store.commit('setCreateMemoRequestType', "Payment");
        this.$router.push('/create-payment-memo');
      } else if (this.createMemoReqType == 'Announcement') {
        this.$store.commit('setCreateMemoRequestType', "Announcement");
        this.$router.push('/create-announcement-memo');
      }
    },
    findMemoExport() {
      var date = new Date(this.exportDates);
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1) +1;
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0) +1;
      
      axios({
        method: 'post',
        url: process.env.VUE_APP_API_OLD + `/api/requests/rangedate`,
        data: {dateStart: firstDay, dateEnd: lastDay}
      })
      .then((res) => {

        this.exportFilename = `G-Memo ${firstDay} - ${lastDay}`

        let memoInRangeT = res.data.data

        let result = []
        
        for ( let i in memoInRangeT ) {
          let wf = memoInRangeT[i].imWorkflow
          let useAlias = memoInRangeT[i].imUseAlias
          let Appvs = ""
          let AppvDates = ""

          for (let j in wf) {
            //-  DEFINE ALIAS
            if (useAlias) Appvs += `${wf[j].alias}\n`
            else if (!useAlias)  Appvs += `${wf[j].name}\n`
            else Appvs += `\n`

            //-  DEFINE APPV DATE
            if (wf[j].date) AppvDates += `${wf[j].date}\n`
            else AppvDates += `-\n`
          }

          memoInRangeT[i].Appvs = Appvs.trim()
          memoInRangeT[i].Stat = this.i18n.status[memoInRangeT[i].imStatus].name
          memoInRangeT[i].AppvDates = AppvDates.trim()

          result.push(memoInRangeT[i])
        }

        this.memoInRange = result
      })
      .catch((e)=> {
        console.log(e) 
      })

      //- http://localhost:3004/api/requests/rangedate/2023-04-19/2023-04-26
    },
    //- exportDatesConf() {
    //-   if (this.exportDates[0] > this.exportDates[1]) this.exportDates = [this.exportDates[1], this.exportDates[0]]
    //- },
    getBisnisUnit() {
      if (this.title == 'My IM Request') {
        this.$store.state.dataUsers.user.bu.map((val) => {
            this.bisnis_unit = this.bisnis_unit.concat({text:val.business_unit.bu_name, value: val.business_unit.id});
        });
      } else {
        this.$store.state.dataUsers.user.bu.map((val) => {
            let dataBu = {
              text: val.business_unit.bu_name,
              value: val.business_unit.id
            }

            let middle = Math.floor(this.bisnis_unit_approval.length / 2);

            this.bisnis_unit_approval.splice(middle, 0, dataBu);

            this.bisnis_unit_approval.reverse()
        });
      }
    },
    EditPage(id){
      this.$router.push(`/memo/edit/${id}`)
    },
    getStatus(data, type, dataWf) {
      if ( type == 'status' ) {

        if(dataWf[0].status == 5) {
            if(data.status == 5) {
              return this.i18n.status[data.status].color;
            }
            return this.i18n.status[1].color;

        } else {
            if ( data.status == undefined ) {
              return this.i18n.status[1].color;
            }
            return this.i18n.status[data.status].color;
        }

      } else if ( type == 'icon' ) {

        if(dataWf[0].status == 5) {
            if(data.status == 5) {
              return this.i18n.status[data.status].icon;
            }
            return

        } else {

          if ( data.status == undefined ) {
            return
          }
          return this.i18n.status[data.status].icon;
        }
      }
    },
    clickColumn(item) {       
      const indexExpanded = this.expanded.findIndex(i => i._id === item._id);
      if (indexExpanded > -1) {
          this.expanded.splice(indexExpanded, 1)
      } else {
            this.expanded.splice(indexExpanded, 1)
            this.expanded.push(item);
      }
    },
    cancel(){
      this.request.cancel()
    },
    getOptions() {
      clearTimeout(this._timerId)
      if(this.request) this.cancel();

      this._timerId = setTimeout(()=>{
        this.$store.state.dataRequests.data = [];
        this.$store.state.dataReqApproval.data = [];
        this.loading = true;
        const search = this.bisnisUnit + "_" + this.e3 + "_" + this.keyword;

        if ( this.options.page == undefined ) {
          this.options.page = 1
        }

        if ( this.options.rowsPerPage == undefined ) {
          this.options.rowsPerPage = this.itemsPerPage
        }
        
        const axiosSource = axios.CancelToken.source()
        this.request = {cancel:axiosSource.cancel}

        if (search.length != 2 && !this.options.sortBy) {
          if (this.title == "Approval Page") {
            axios
              .get(
                process.env.VUE_APP_API_OLD + `/api/approval/requests/${this.$store.state.dataUsers.user._id}/refactor?query=${search.trim()}&page=${this.options.page}&per_page=${this.options.rowsPerPage}`,
                {
                  auth: {
                    username: "imemo",
                    password: "Ang3lT3n4n!#"
                  },
                  cancelToken:axiosSource.token
                }
              )
              .then(res => {
                this.$store.state.dataReqApproval.data = res.data.data;
                this.$store.state.dataReqApproval.jumlah = res.data.jumlah;
                this.request=null
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => (this.loading = false));
          } else if (this.title == "My IM Request") {
            //- axios
            //-   .get(
            //-     process.env.VUE_APP_API_OLD + `/api/requests/refactor?_id=${this.$store.state.dataUsers.user._id}&query=${search.trim()}&page=${this.options.page}&per_page=${this.options.rowsPerPage}`,
            //-   )
            //-   .then(res => {
            //-     this.$store.state.dataRequests.data = res.data.data;
            //-     this.$store.state.dataRequests.jumlah = res.data.jumlah;
            //-     this.request=null
            //-   })
            //-   .catch(err => {
            //-       console.log(err)
            //-   })
            //-   .finally(() => (this.loading = false));
          }
        } else if (this.options.sortBy) {
          const direction = this.options.sortDesc[0] ? -1 : 1;
          let sortBy = this.options.sortBy;
          if (sortBy[0] == "imNilai") sortBy = "imValue";
          if (sortBy[0] == "imStatusLabel") sortBy = "imStatus";
          if (this.title == "Approval Page") {
            let token = localStorage.getItem("token");
            const config = {
              method: "post",
              url: process.env.VUE_APP_API_OLD + `/api/v2/approval/requests/${this.$store.state.dataUsers.user._id}`,
              headers: {"Authorization": `Bearer ${token}`},
              data: {
                "buId": this.bisnisUnit.length > 0  && !this.selectAllBUApproval ? this.bisnisUnit : [],
                "imStatus": this.e3.length > 0 ? this.e3 : [],
                "category": this.category.length > 0 ? this.category : [],
                "direction": direction,
                "sortBy": sortBy[0],
                "keyword": this.keyword.trim(),
                "page": this.options.page,
                "perPage": this.options.rowsPerPage
              },
            };
            config.data.filterImType = this.filterImType,
            axios(config)
              .then(res => {
                this.$store.state.dataReqApproval.data = res.data.data;
                this.$store.state.dataReqApproval.jumlah = res.data.jumlah;
                this.request=null
              })
              .catch(err => { 
                console.log(err)
              })
              .finally(()=>this.loading=false)
          } else if (this.title == "My IM Request") {
            // THIS ONE
            let token = localStorage.getItem("token");
            const config = {
              method: "post",
              url: process.env.VUE_APP_API_OLD + `/api/v2/requests`,
              headers: {"Authorization": `Bearer ${token}`},
              data: {
                "userId": this.$store.state.dataUsers.user._id,
                "buId": this.bisnisUnit.length > 0 ? this.bisnisUnit : [],
                "imStatus": this.e3.length > 0 ? this.e3 : [],
                "category": this.category.length > 0 ? this.category : [],
                "direction": direction,
                "sortBy": sortBy[0],
                "keyword": this.keyword.trim(),
                "page": this.options.page,
                "perPage": this.options.rowsPerPage
              },
            };
            config.data.filterImType = this.filterImType,
            axios(config)
              .then(res => {
                this.page = this.options.page
                this.$store.state.dataRequests.data = res.data.data || [];
                this.$store.state.dataRequests.jumlah = res.data.jumlah || 0;
                this.request=null
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => (this.loading = false));
          }
        } else if (search.length == 2) {
          if (this.title == "Approval Page") {
            const config = {
              method: "post",
              url: process.env.VUE_APP_API_OLD + `/api/v2/approval/requests/${this.$store.state.dataUsers.user._id}`,
              headers: {"Authorization": `Bearer ${token}`},
              data: {
                "buId": this.bisnisUnit.length > 0 ? this.bisnisUnit : [],
                "imStatus": this.e3.length > 0 ? this.e3 : [],
                "category": this.category.length > 0 ? this.category : [],
                "direction": 1,
                "sortBy": sortBy,
                "keyword": search,
                "page": this.options.page,
                "perPage": this.options.rowsPerPage
              },
            };
            config.data.filterImType = this.filterImType,
            axios(config)
            .then(res => {
              //- this.$store.state.dataReqApproval.data = res.data.data;
              //- this.$store.state.dataReqApproval.jumlah = res.data.jumlah;
              this.$store.state.dataReqApproval = { data: res.data.data, jumlah: res.data.jumlah };
              
              this.request=null
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => (this.loading = false));
          } else if (this.title == "My IM Request") {
            //- axios
            //-   .get(
            //-     process.env.VUE_APP_API_OLD + `/api/requests/refactor?_id=${this.$store.state.dataUsers.user._id}&page=${this.options.page}&per_page=${this.options.rowsPerPage}`,
            //-     {
            //-       auth: {
            //-         username: "imemo",
            //-         password: "Ang3lT3n4n!#"
            //-       },
            //-       cancelToken:axiosSource.token
            //-     }
            //-   )
            //-   .then(res => {
            //-     this.$store.state.dataRequests.data = res.data.data;
            //-     this.$store.state.dataRequests.jumlah = res.data.jumlah;
            //-     this.request=null
            //-   })
            //-   .catch(err => {
            //-     console.log(err)
            //-   })
            //-   .finally(() => (this.loading = false));
          }
        }
      },500)
    },
    routeName(val) {
      if ([1, 2, 3].includes(val)) {
        return "Edit IM Budget";
      } else if (val == 4) {
        return "Edit IM Proposal Investasi";
      } else if (val == 5) {
        return "Edit IM General";
      } else if (val == 6) {
        return "Edit IM Announcement";
      } else if (val == 7) {
        return "Edit Document Legal F1";
      } else if (val == 8) {
        return "Edit Document Legal F2";
      } else if (val == 9) {
        return "Edit IM Treasury";
      } else if (val == 10) {
        return "Edit IM Forex";
      } else if (val == 11) {
        return "Edit Internal Memo";
      }
    },
    getUTC7Date(tgl) {
      let tanggal = new Date(tgl);
      let month =
        tanggal.getMonth() + 1 < 10
          ? "0" + (tanggal.getMonth() + 1)
          : tanggal.getMonth() + 1;
      let date =
        tanggal.getDate() < 10
          ? "0" + tanggal.getDate()
          : tanggal.getDate();
      return tanggal.getFullYear() + "-" + month + "-" + date;
    },
    customFilter(items, search, filter) {
      //-MENGGUNAKAN METODE NESTED QUERY
      let hasil = search.split("_");
      //FILTER DARI TIPE
      if (hasil[0]) {
        var jenis = items.filter(i => {
          return !hasil[0] || i.imTypeLabel === hasil[0];
        });
        //UNTUK SEARCH
        if (hasil[2] && (hasil[1] || !hasil[1])) {
          let e4 = hasil[2].toString().toLowerCase();
          var searching = jenis.filter(i =>
            Object.keys(i).some(j => filter(i[j], e4))
          );
          if (hasil[2] && (!hasil[1] || hasil[1])) {
            var status2 = searching.filter(l => {
              return !hasil[1] || l.imStatusLabel === hasil[1];
            });
            return status2;
          }
          return searching;
        }
        //UNTUK STATUS
        if (hasil[1]) {
          var statuslabel = jenis.filter(l => {
            return !hasil[1] || l.imStatusLabel === hasil[1];
          });
          return statuslabel;
        }
        return jenis;
      }
      //FILTER DARI STATUS
      if (hasil[1]) {
        var statusitems = items.filter(l => {
          return !hasil[1] || l.imStatusLabel === hasil[1];
        });
        if (hasil[2] && (hasil[0] || !hasil[0])) {
          let e4 = hasil[2].toString().toLowerCase();
          searching = statusitems.filter(i =>
            Object.keys(i).some(j => filter(i[j], e4))
          );
          if (hasil[2] && (!hasil[0] || hasil[0])) {
            status2 = searching.filter(l => {
              return !hasil[0] || l.imTypeLabel === hasil[0];
            });
            return status2;
          }
          return searching;
        }
        if (hasil[0]) {
          var tipeim = statusitems.filter(l => {
            return !hasil[0] || l.imStatusLabel === hasil[0];
          });
          return tipeim;
        }
        return statusitems;
      }
      //FILTER DARI SEARCH
      if (hasil[2] && (!hasil[1] || hasil[1])) {
        let e5 = hasil[2].toString().toLowerCase();
        var searched = items.filter(i =>
          Object.keys(i).some(j => filter(i[j], e5))
        );
        if (hasil[1]) {
          return searched.filter(l => {
            return !hasil[1] || l.imStatusLabel === hasil[1];
          });
        }
        return searched;
      }

      return items;
    },
    exportExcel(userId) {
      window.open(`${this.API_URL}/api/approval/export/excel/${userId}`);
    },
    isDelivery(imItem) {
      try {
        let result = false;
        if (imItem.imPiNumber) {
          result = true;
        }
        return result;
      } catch (e) {
        return false;
      }
    },
    expandAndRemoveNotif(props) {
      props.expanded = !props.expanded;
    },
    download(imNo) {
      this.overlay = true;
      const URL = process.env.VUE_APP_API+`/requests/download_zip/`+imNo;
      axios.head(URL)
        .then(response => {
            const statusCode = response.status;
            if (statusCode === 404 || statusCode === 500) {
                this.overlay = false;
                this.$toasted.error('Download failed!', { icon : 'error'})
            } else {
                this.overlay = false;
                window.location.href = URL;
            }      
        })
        .catch(err => {
            this.overlay = false;
            this.$toasted.error('Download failed!', { icon : 'error'})
        })
    },
    isReviewer(workflow, dataUsers) {
      let result = false;
      let approver = false;
      for (var i = workflow.length - 1; i >= 0; i--) {
        if (workflow[i].status == 3) approver = true;
        if (workflow[i].status == 3 && dataUsers._id == workflow[i].user_id) {
          result = true;
          break;
        }
      }
      if (!approver && i == -1) result = true;
      return result;
    },
    getReviewer(im) {
      let approver = false;
      for (var i = im.imWorkflow.length - 1; i >= 0; i--) {
        if (im.imWorkflow[i].status == 3) return im.imWorkflow[i];
      }
      if (!approver && i == -1) return im.imUser;
    },
    toggle () {
      this.$nextTick(() => {
        if (this.selectAllBU) {
          this.bisnisUnit = []
        } else {
          const dta = this.dataBisnisUnit.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.bisnisUnit = result
        }
      })
    },
    toggleImType () {
      this.$nextTick(() => {
        // filterImType
        if (this.selectAllImType) {
          this.filterImType = []
        } else {
          const dta = this.dataImType.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.filterImType = result
        }
      })
    },
    toggleStatus () {
      this.$nextTick(() => {
        if (this.selectAllStatus) {
          this.e3 = []
        } else {
          const dta = this.dataStatus.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.e3 = result
        }
      })
    },
    toggleCategory() {
      this.$nextTick(() => {
        if (this.selectAllCategory) {
          this.category = []
        } else {
          const dta = this.dataCategory.slice().filter((v,i,a)=>a.findIndex(v2=>(v2.value===v.value))===i)
          let result = []
          for(let i in dta) result.push(dta[i].value)
          this.category = result
        }
      })
    },
    remove(id, type) {
      if ( type == 'bisnis unit' ) {
        let idx = this.bisnisUnit.indexOf(id)
        this.bisnisUnit.splice(idx, 1)
        this.bisnisUnit = [...this.bisnisUnit]

      } else if ( type == 'status' ) {
        let idx = this.e3.indexOf(id)
        this.e3.splice(idx, 1)
        this.e3 = [...this.e3]

      } else if ( type == 'category' ) {
        let idx = this.category.indexOf(id)
        this.category.splice(idx, 1)
        this.category = [...this.category]

      } else if ( type == 'imType' ) {
        let idx = this.filterImType.indexOf(id)
        this.filterImType.splice(idx, 1)
        this.filterImType = [...this.filterImType]
      }

      //- 
       
    },
    removeAll(type) {
      if ( type == 'bisnis unit' ) {
        this.bisnisUnit = ''
      } else if ( type == 'status' ) {
        this.e3 = ''
      } else if ( type == 'category' ) {
        this.category = ''
      } else if ( type == 'imType' ) {
        this.filterImType = ''
      }
      
    },
  }
};
</script>

<style>

select:required:invalid {
  color: gray;
}
option {
  color: black;
}
.pointer {
  cursor: pointer;
}
</style>



